// extracted by mini-css-extract-plugin
export default {"wrapper":"PopupDetailsGiftShop_wrapper__URd8N","img":"PopupDetailsGiftShop_img__jdeNT"};